export const BRANCH = "branch";

export const NODE_TYPE_COMPANY = "company";
export const NODE_TYPE_REGION = "region";
export const NODE_TYPE_BRANCH = "branch";

export const NODE_STATUS_ACTIVE = "active";
export const NODE_STATUS_INACTIVE = "inactive";